<template>
    <div>
        <v-container>
            <v-card-actions>
                <router-link to="/courses">
                    <v-btn :style="{ color: 'white', 'background-color': 'rgb(127, 127, 127)' }"> Back </v-btn>
                </router-link>
            </v-card-actions>
            <h1>{{ card.title }}</h1>
            <!-- Título y subtítulo             
            <h3>{{ card.subtitle }}</h3>-->
            <v-divider></v-divider>
            <!-- Descripción -->
            <v-spacer></v-spacer>
            <br>
            <v-row>
                <v-col cols="12" md="12" lg="12">
                    <v-img class="align-end text-white" contain :style="{ 'max-width': '180vh', 'max-height': '50vh' }" :src="getImageSrc(card.images)"></v-img>
                </v-col>
            </v-row>
            <v-row>                
                <v-col cols="12" md="6" lg="12">
                    <p style="font-size: 50px; color: rgb(15, 135, 201);"><b>________________________________________________</b></p>
                    <!---->
                    <details @click="mostrarAdjuntosCategories(5)" open>
                        <summary id="cat5">
                            <p><b>Elearning</b></p>
                        </summary>
                        <div>
                            <p>
                                <b>UNODC Teaching Modules</b><br>
                                    The United Nations Office on Drugs and Crime has co-created and jointly developed a series of peer-reviewed teaching modules and other tools with academics 
                                    to assist them in teaching on some of today's most crucial threats. Specifically, the series of teaching modules aims to support tertiary level educators and 
                                    academics in their efforts to transmit knowledge and create a deeper understanding of rule of law related issues, with a focus on the subject areas of organized crime, 
                                    trafficking in persons and smuggling of migrants, firearms, cybercrime, wildlife crime as well as counter-terrorism. More than 600 
                                    <a href="https://sherloc.unodc.org/cld/en/education/tertiary/acknowledgements.html" target="_blank">academics and national experts</a> from more than 550 universities 
                                    and 114 countries contributed to the development of the module series and participated in related activities.<br><br>

                                    The teaching modules are designed for use as either stand-alone teaching resources, or as a means of enhancing existing courses in criminology, law, political science, 
                                    international relations, sociology, and many other disciplines. A “pick and choose” approach allows for lecturers to seamlessly fit them into current syllabi. Alternatively, 
                                    lectures can use the <a href="https://sherloc.unodc.org/cld/en/education/tertiary/build-your-course.html" target="_blank">“create your own course”</a> feature and combine 
                                    modules form different thematic areas to suit their needs.<br><br>

                                    Open source and available for free, we invite academics to use the materials, provide us with <a href="https://sherloc.unodc.org/cld/en/st/contact-us.html" target="_blank">
                                    feedback</a>. Let's join forces in shaping tomorrow's leaders and empowering the next generation to tackle the most pressing global challenges posed by 
                                    crime and help to achieve SDG 16, more just, peaceful and inclusive societies.
                                    <a href="https://sherloc.unodc.org/cld/en/education/terms-of-use-and-disclaimers/university-modules.html" target="_blank">Terms of Use and Disclaimers for Teaching Modules</a><br><br>

                                    <b>Teaching module series:</b><br>
                                    <ul>
                                        <li><a href="https://sherloc.unodc.org/cld/en/education/tertiary/organized-crime.html" target="_blank">ORGANIZED CRIME</a></li>
                                        <li><a href="https://sherloc.unodc.org/cld/en/education/tertiary/trafficking-in-persons-smuggling-of-migrants.html" target="_blank">TRAFFICKING IN PERSONS AND SMUGGLING OF MIGRANTS</a></li>
                                        <li><a href="https://sherloc.unodc.org/cld/en/education/tertiary/firearms.html" target="_blank">FIREARMS</a></li>
                                        <li><a href="https://sherloc.unodc.org/cld/en/education/tertiary/cybercrime.html" target="_blank">CYBERCRIME</a></li>
                                        <li><a href="https://sherloc.unodc.org/cld/en/education/tertiary/wildlife-crime.html" target="_blank">WILDLIFE CRIME</a></li>
                                    </ul>
                            </p>
                            <p>
                                <b><a href="https://www.unodc.org/elearning/" target="_blank">UNODC Global Elearning Programme</a></b><br>
                                    UNODCs online eLearning courses deliver trainings to a community of over 50,000 Member State officials on international security threats such as transnational 
                                    organized crime, terrorism, illicit drugs, trafficking in persons and smuggling of migrants, wildlife and forest crime, cybercrime as well as provide training on 
                                    border control, intelligence analysis, gender issues, anticorruption, HIV/AIDS and human rights.<br>
                                    These courses, developed by leading international experts, enable law enforcement officers and other professionals to expand their knowledge and stay up to date with 
                                    the international community's fight against illicit drugs, crime and terrorism experts in line with United Nations standards and norms and other relevant international 
                                    instruments.<br>
                                    The programme offers training 24/7 across the world through the delivery of online and offline training to Member States in line with the United Nations standards 
                                    and norms and other relevant international instruments and strengthens the capacity of governments to better meet human security and health needs and challenges through 
                                    eLearning.<br>
                                    Each learning module is developed in English and is then translated into other languages, upon request from Member States. There are currently more than 486 modules in 
                                    English and in 21 other languages. This number is constantly growing as a result of new production and continuous translation of existing modules into different languages.
                                    Each eLearning course can contain one or more modules and has its own web-links and resources.<br><br>
                            </p>
                            <p>
                                <b>UNODC/UN Women Module on Gender Equality and Organized Crime</b><br>
                                    <a href="https://portal.trainingcentre.unwomen.org/product/i-know-gender-17-gender-equality-and-organized-crime/" target="_blank">English</a> - 
                                    <a href="https://portal.trainingcentre.unwomen.org/product/yo-se-de-genero-17/" target="_blank">Spanish</a>
                            </p>                            
                            <!-- 
                            <p><b>Tools and Resources</b></p>
                            
                            <ul class="document-columns">
                                <li v-for="(nombreArchivo, index) in nombresAdjuntos5" :key="index">
                                    <a @click="descargarCategory(5, nombreArchivo)" target="_blank" style="text-decoration: underline; color: var(--v-anchor-base);">
                                    {{ nombreArchivo }}
                                    </a>
                                </li>
                            </ul>-->
                        </div>
                    </details>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    data() {
        return {            
            nombresAdjuntos: [],//Category
            nombresAdjuntos2: [],//Category
            nombresAdjuntos3: [],//Category
            nombresAdjuntos4: [],//Category
            nombresAdjuntos5: [],//Category
            nombresAdjuntosSub1: [],//Sub Category
            nombresAdjuntosSub2: [],//Sub Category
            nombresAdjuntosSub3: [],//Sub Category
            nombresAdjuntosSub4: [],//Sub Category
            nombresAdjuntosSub5: [],//Sub Category
            nombresAdjuntosSub6: [],//Sub Category
            nombresAdjuntosSub7: [],//Sub Category
            nombresAdjuntosSub2_1: [],
            nombresAdjuntosSub2_2: [],
            nombresAdjuntosSub2_3: [],//Firearms
            nombresAdjuntosSub2_4: [],//Firearms
            card: {
                id: 0,
                title: '',
                subtitle: '',
                description: '',
                additionalInfo: '',
                additionalInfo2: '',
                images: [],
                chip: [],
            },
            cards: [
                {
                    id: 2,
                    title: 'ORGANIZED CRIME',
                    subtitle: 'UNODC',
                    category: '<p><b></p></b>'+
                        '<ul>'+
                            '<li><a href="#cat1" style="text-decoration: none;">2.1. Organized Crime (General)</a></li>'+
                                '<ul>'+
                                    '<li><a href="#cat1_1" style="text-decoration: none;">2.1.1. Databases</a></li>'+
                                    '<li><a href="#cat1_2" style="text-decoration: none;">2.1.2. UN Policy Papers and Handbooks</a></li>'+
                                    '<li><a href="#cat1_3" style="text-decoration: none;">2.1.3. Assessment Tools</a></li>'+
                                '</ul>'+
                            '<li><a href="#cat2" style="text-decoration: none;">2.2. UN Convention on Transnational Organized Crime</a></li>'+
                                '<ul>'+
                                    '<li><a href="#cat2_1" style="text-decoration: none;">2.2.1 Conference of State Parties of UNTOC</a></li>'+
                                    '<li><a href="#cat2_2" style="text-decoration: none;">2.2.2 Review Mechanism of UNTOC and Country Profiles</a></li>'+
                                '</ul>'+
                            '<li><a href="#cat3" style="text-decoration: none;">2.3. Thematic Areas of Organized Crime</a></li>'+
                                '<ul>'+
                                    '<li><a href="#cat3_1" style="text-decoration: none;">2.3.1. Human Trafficking and Migrant Smuggling</a></li>'+
                                        '<ul>'+
                                            '<li><a href="#cat3_1_1" style="text-decoration: none;">2.3.1.1. Human Trafficking</a></li>'+
                                                '<ul>'+
                                                    '<li>2.3.1.1.1. The Crime</li>'+
                                                    '<li>2.3.1.1.2. The Protocol</li>'+
                                                    '<li>2.3.1.1.3. The Response</li>'+
                                                    '<li>2.3.1.1.4. Tools and Resources</li>'+
                                                    '<li>2.3.1.1.5. Partnerships</li>'+
                                                    '<li>2.3.1.1.6. Training Material</li>'+
                                                    '<li>2.3.1.1.7. Multimedia</li>'+
                                                '</ul>'+
                                        '</ul>'+
                                        '<ul>'+
                                            '<li><a href="#cat3_1_2" style="text-decoration: none;">2.3.1.2 Migrant Smuggling</a></li>'+
                                                '<ul>'+
                                                    '<li>2.3.1.2.1. The Crime</li>'+
                                                    '<li>2.3.1.2.2. The Protocol</li>'+
                                                    '<li>2.3.1.2.3. The response</li>'+
                                                    '<li>2.3.1.2.4. Tools and resources</li>'+
                                                    '<li>2.3.1.2.5. Partnerships</li>'+
                                                    '<li>2.3.1.2.6. Training Material</li>'+
                                                    '<li>2.3.1.2.7. Multimedia</li>'+
                                                '</ul>'+
                                        '</ul>'+                                    
                                    '<li><a href="#cat3_2" style="text-decoration: none;">2.3.2 Illicit Manufacturing and Trafficking in Firearms</a></li>'+
                                        '<ul>'+
                                            '<li>2.3.2.1. The Crime</li>'+
                                            '<li>2.3.2.2. The Firearms Protocol </li>'+
                                            '<li>2.3.2.3. The International Legal Regime</li>'+
                                            '<li>2.3.2.4. The Response</li>'+
                                            '<li>2.3.2.5. Tools and Resources</li>'+
                                        '</ul>'+
                                    '<li><a href="#cat3_3" style="text-decoration: none;">2.3.3. Cybercrime</a></li>'+
                                        '<ul>'+
                                            '<li>2.3.3.1. The Crime</li>'+
                                            '<li>2.3.3.2. The Response</li>'+
                                            '<li>2.3.3.3. Tools and Resources</li>'+
                                        '</ul>'+
                                    '<li><a href="#cat3_4" style="text-decoration: none;">2.3.4. Money Laundering</a></li>'+
                                        '<ul>'+
                                            '<li>2.3.4.1. The Legal Framework</li>'+
                                            '<li>2.3.4.2. The Crime</li>'+
                                            '<li>2.3.4.3. The Response</li>'+
                                            '<li>2.3.4.4. Tools and Resources</li>'+
                                        '</ul>'+
                                    '<li><a href="#cat3_5" style="text-decoration: none;">2.3.5. Border management</a></li>'+
                                        '<ul>'+
                                            '<li>2.3.5.1. Air</li>'+
                                                '<ul>'+
                                                    '<li>2.3.5.1.1.	The Response</li>'+
                                                    '<li>2.3.5.1.2.	Tools and Resources/li>'+
                                                '</ul>'+
                                            '<li>2.3.5.2. Sea</li>'+
                                                '<ul>'+
                                                    '<li>2.3.5.2.1.	The Response</li>'+
                                                    '<li>2.3.5.2.2.	Tools and Resources</li>'+
                                                '</ul>'+
                                            '<li>2.3.5.3. Land</li>'+
                                                '<ul>'+
                                                    '<li>2.3.5.3.1.	The Response</li>'+
                                                    '<li>2.3.5.3.2.	Tools and Resources</li>'+
                                                '</ul>'+
                                        '</ul>'+
                                    '<li><a href="#cat3_6" style="text-decoration: none;">2.3.6. Crimes that affect the Environment</a></li>'+
                                        '<ul>'+
                                            '<li>2.3.6.1. The Crimes</li>'+
                                            '<li>2.3.6.2. The Legal Framework</li>'+
                                            '<li>2.3.6.3. The Response</li>'+
                                            '<li>2.3.6.4. Tools and Resources</li>'+
                                        '</ul>'+
                                '</ul>'+
                            '<li><a href="#cat4" style="text-decoration: none;">2.4. International Cooperation</a></li>'+
                                '<ul>'+
                                    '<li>4.1. Tools and Resources</li>'+
                                '</ul>'+
                            '<li><a href="#cat5" style="text-decoration: none;">2.5. Elearning</a></li>'+
                        '</ul>',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 3',
                    additionalInfo2: 'The United Nations system assists Member States in their fight against transnational organised crime.'+
                    '<a href="http://www.unodc.org/unodc/treaties/#Drugrelated" target="_blank">A number of international conventions on drug control</a>, and more recently '+
                    '<a href="http://www.unodc.org/unodc/en/treaties/CTOC/index.html" target="_blank">the UN Convention against Transnational Organized Crime and its protocols on human trafficking, migrant smuggling and trafficking of firearms , </a>'+
                    'as well as <a href="http://www.unodc.org/unodc/en/treaties/CAC/index.html" target="_blank">the UN Convention against Corruption, </a>'+
                    'constitute the key framework for a strategic response. <a href="http://www.unodc.org/unodc/index.html" target="_blank">The United Nations Office on Drugs and Crime</a> is the guardian of the related international conventions.',
                    images: ['2.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/UNESCO%20rule%20of%20law%20through%20education?csf=1&web=1&e=3Dt35A',
                },
            ],
        };  
    },
    methods: {
        descargarArchivo(nombreArchivo) {
            //const url = `https://localhost:7254/api/Categories/MostrarOrganizeCrime/${nombreArchivo}`;//local
            const url = `https://unlabccback.rocol.org/api/Categories/MostrarOrganizeCrime/${nombreArchivo}`;//local
            
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('target', '_blank'); // Para abrir el archivo en una nueva pestaña
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        descargarCategory(id, nombreArchivo) {
            //const url = `https://localhost:7254/api/Categories/MostrarSoporte3/${id}/${nombreArchivo}`;//local
            const url = `https://unlabccback.rocol.org/api/Categories/MostrarSoporte3/${id}/${nombreArchivo}`;//local
            // Extraer la extensión del archivo
            const extension = nombreArchivo.split('.').pop().toLowerCase();

            // Crear una solicitud HTTP
            const xhr = new XMLHttpRequest();

            // Configurar la solicitud
            xhr.open('GET', url, true);
            xhr.responseType = 'blob'; // Establecer el tipo de respuesta como blob (Binary Large Object)

            // Configurar la gestión de la carga
            xhr.onload = function () {
                if (xhr.status === 200) {
                    // Crear un objeto Blob con el contenido de la respuesta
                    const blob = new Blob([xhr.response], { type: xhr.getResponseHeader('Content-Type') });

                    // Verificar la extensión del archivo
                    if (extension === 'pdf') {
                        // Si es un PDF, abrir en una nueva pestaña
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.setAttribute('target', '_blank');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    } else {
                        // Para otras extensiones, descargar
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = nombreArchivo;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                }
            };

            // Enviar la solicitud
            xhr.send();
        },
        // Función para obtener y mostrar los nombres de archivo de los adjuntos del proceso
        async mostrarAdjuntosCategories(id) {
            try {
                const response = await axios.get(`api/Categories/MostrarCategoriesOrganizeCrime/${id}`);
                switch (id) {
                    case 1:
                        this.nombresAdjuntos = response.data;
                        break;
                    case 2:
                        this.nombresAdjuntos2 = response.data;
                        break;
                    case 3:
                        this.nombresAdjuntos3 = response.data;
                        break;
                    case 4:
                        this.nombresAdjuntos4 = response.data;
                        break;
                    case 5:
                        this.nombresAdjuntos5 = response.data;
                        break;
                    default:
                        console.error("ID no válido:", id);
                        break;
                }
            } catch (error) {
                console.error(error);
                this.nombresAdjuntos = []; // En caso de error, devuelve una lista vacía o realiza otra acción adecuada
            }
        },
        // Función para obtener y mostrar los nombres de archivo de los adjuntos del proceso
        async mostrarAdjuntosSubCategories(id, id2) {
            try {
                const response = await axios.get(`api/Categories/MostrarSubCategoriesOrganizeCrime/${id}/${id2}`);
                switch (id2) {
                    case 1:
                        this.nombresAdjuntosSub1 = response.data;
                        break;
                    case 2:
                        this.nombresAdjuntosSub2 = response.data;
                        break;
                    case 3:
                        this.nombresAdjuntosSub3 = response.data;
                        break;
                    case 4:
                        this.nombresAdjuntosSub4 = response.data;
                        break;
                    case 5:
                        this.nombresAdjuntosSub5 = response.data;
                        break;
                    case 6:
                        this.nombresAdjuntosSub6 = response.data;
                        break;
                    case 7:
                        this.nombresAdjuntosSub7 = response.data;
                        break;
                    default:
                        console.error("ID no válido:", id);
                        break;
                }
            } catch (error) {
                console.error(error);
                this.nombresAdjuntosSub1 = []; // En caso de error, devuelve una lista vacía o realiza otra acción adecuada
            }
        },
        descargarSubCategory(id, id2, nombreArchivo) {
            //const url = `https://localhost:7254/api/Categories/MostrarSoporte3_1/${id}/${id2}/${nombreArchivo}`;//local
            const url = `https://unlabccback.rocol.org/api/Categories/MostrarSoporte3_1/${id}/${id2}/${nombreArchivo}`;//local
            // Extraer la extensión del archivo
            const extension = nombreArchivo.split('.').pop().toLowerCase();

            // Crear una solicitud HTTP
            const xhr = new XMLHttpRequest();

            // Configurar la solicitud
            xhr.open('GET', url, true);
            xhr.responseType = 'blob'; // Establecer el tipo de respuesta como blob (Binary Large Object)

            // Configurar la gestión de la carga
            xhr.onload = function () {
                if (xhr.status === 200) {
                    // Crear un objeto Blob con el contenido de la respuesta
                    const blob = new Blob([xhr.response], { type: xhr.getResponseHeader('Content-Type') });

                    // Verificar la extensión del archivo
                    if (extension === 'pdf') {
                        // Si es un PDF, abrir en una nueva pestaña
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.setAttribute('target', '_blank');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    } else {
                        // Para otras extensiones, descargar
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = nombreArchivo;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                }
            };

            // Enviar la solicitud
            xhr.send();
        },
        // Función para obtener y mostrar los nombres de archivo de los adjuntos del proceso
        async mostrarAdjuntosSubCategories2(id, id2, id3) {
            try {
                const response = await axios.get(`api/Categories/MostrarSubCategoriesOrganizeCrime2/${id}/${id2}/${id3}`);
                switch (id3) {
                    case 1:
                        this.nombresAdjuntosSub2_1 = response.data;
                        break;
                    case 2:
                        this.nombresAdjuntosSub2_2 = response.data;
                        break;
                    case 3:
                        this.nombresAdjuntosSub2_3 = response.data;
                        break;
                    case 4:
                        this.nombresAdjuntosSub2_4 = response.data;
                        break;
                    default:
                        console.error("ID no válido:", id);
                        break;
                }
            } catch (error) {
                console.error(error);
                this.nombresAdjuntosSub1 = []; // En caso de error, devuelve una lista vacía o realiza otra acción adecuada
            }
        },

        descargarSubCategory2(id, id2, id3, nombreArchivo) {
            //const url = `https://localhost:7254/api/Categories/MostrarSoporte3_2/${id}/${id2}/${id3}/${nombreArchivo}`;//local
            const url = `https://unlabccback.rocol.org/api/Categories/MostrarSoporte3_2/${id}/${id2}/${id3}/${nombreArchivo}`;//local
            // Extraer la extensión del archivo
            const extension = nombreArchivo.split('.').pop().toLowerCase();

            // Crear una solicitud HTTP
            const xhr = new XMLHttpRequest();

            // Configurar la solicitud
            xhr.open('GET', url, true);
            xhr.responseType = 'blob'; // Establecer el tipo de respuesta como blob (Binary Large Object)

            // Configurar la gestión de la carga
            xhr.onload = function () {
                if (xhr.status === 200) {
                    // Crear un objeto Blob con el contenido de la respuesta
                    const blob = new Blob([xhr.response], { type: xhr.getResponseHeader('Content-Type') });

                    // Verificar la extensión del archivo
                    if (extension === 'pdf') {
                        // Si es un PDF, abrir en una nueva pestaña
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.setAttribute('target', '_blank');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    } else {
                        // Para otras extensiones, descargar
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = nombreArchivo;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                }
            };

            // Enviar la solicitud
            xhr.send();
        },
        
        /*
        async listar() {
            try {
                const response = await axios.get('api/Publication/Listar');
                this.datos = response.data;

                // Ahora que tienes los datos, puedes mapearlos al formato que esperas para las tarjetas (cards)
                this.cards = this.datos.map(category => {
                    return {
                        id: category.oid,
                        title: category.title,
                        subtitle: category.subtitle,
                        description: category.description,
                        images: ['fondo2.jpg'],   // Asegúrate de manejar el caso donde images es null o undefined
                    };
                });
            } catch (error) {
                console.error(error);
            }
        },*/
        getImageSrc(filename) {
            if (!filename) return ''; // Agregar una verificación aquí
            return require(`../../assets/${filename}`);
        }
    },
    created() {
        const cardId = parseInt(this.$route.params.id);
        this.card = this.cards.find(card => card.id === cardId);
    },
};
</script>
<style>
    p {
        font-family: 'Heebo', sans-serif;
        font-size: 16px;        
        line-height: 1.6em;
    }
    h1 {
        font-family: 'Heebo', sans-serif;
    }
    h2 {
        font-family: 'Heebo', sans-serif;
    }
    h3 {
        font-family: 'Heebo', sans-serif;
    }
    details { 
        background-color: #f6f8fa;
        width: 100%;
        margin-bottom: 1rem;   
        border-radius: 8px;  
        border: 1px solid #d8e0e9;
        color: #364f6b;
        position: relative;  
    }
    details[open] summary {
        border-bottom: 1px solid #aaa;
        margin-bottom: 0.5em;
    }
    details summary {  
        font-weight: 400;
        font-size: 1.25rem;
        padding: 1rem;
        cursor: pointer;
        list-style: none;
    }
    details summary::before {
        content: "▶"; /* Flecha hacia la derecha */
        font-size: 1.5rem;
        line-height: 1.5rem;
        color: #364f6b;
        position: absolute;
        left: 97%; /* Ajusta el espacio entre la flecha y el texto */
    }
    details[open] summary::before {
        content: "▼"; /* Flecha hacia abajo cuando details está abierto */
    }
    .document-columns {
        columns: 2; /* Divide la lista en dos columnas */
        column-gap: 20px; /* Espacio entre las columnas */
    }
</style>